// extracted by mini-css-extract-plugin
module.exports = {"one-logo":"one-logo-5754a3ef","oneLogo":"one-logo-5754a3ef"};